import { MUI, colors } from 'ci-esi-web-shared';
import { t } from 'i18next';

type ShapefileItemsProps = {
  items: string[];
  handleDownload: (filename: string, downloadFromPlay: boolean) => void;
  shouldDownloadFromPlay?: boolean;
};

export const ShapefileItems = ({ items, handleDownload, shouldDownloadFromPlay = false }: ShapefileItemsProps) => {
  return (
    <>
      {items.map((item) => (
        <MUI.ListItem key={item} sx={{ justifyContent: 'space-between' }}>
          <MUI.Typography variant="h2" component="span" sx={{ maxWidth: 350 }}>
            {item}
          </MUI.Typography>
          <MUI.Button
            variant="contained"
            size="small"
            style={{ backgroundColor: colors.primary, color: colors.primaryWhite }}
            onClick={() => handleDownload(item, shouldDownloadFromPlay)}
          >
            {t(`OPERATIONS.DOWNLOAD`)}
          </MUI.Button>
        </MUI.ListItem>
      ))}
    </>
  );
};
